export const faqs = [
  {
    question: '黑料网吃瓜的资讯来源可靠吗？',
    answer: '黑料网吃瓜汇聚全网各大娱乐资讯平台的最新爆料，我们的编辑团队会对每一条资讯进行多方核实与筛选，确保为读者提供真实可靠的吃瓜内容。对于未经证实的信息，我们会在文章中明确标注来源和可信度等级。',
  },
  {
    question: '如何在黑料网吃瓜上投稿或提供线索？',
    answer: '欢迎广大网友通过我们的联系方式提供爆料线索。您可以通过网站底部的联系方式发送邮件，或通过社交媒体私信向我们投稿。我们承诺对所有提供线索的网友信息严格保密，对于被采纳的重要爆料，还会给予相应的奖励。',
  },
  {
    question: '黑料网吃瓜的内容更新频率是怎样的？',
    answer: '我们的编辑团队全天候关注娱乐圈最新动态，确保热点事件在第一时间推送到网站。通常情况下，网站每小时都会有内容更新，重大突发事件我们会做到实时跟踪报道。',
  },
  {
    question: '网站上的文章可以转载吗？',
    answer: '黑料网吃瓜上的原创内容受版权保护。如需转载，请通过官方渠道联系我们的内容团队获取授权。未经授权擅自转载的行为，我们将保留追究法律责任的权利。',
  },
  {
    question: '如何投诉或举报不实信息？',
    answer: '如果您发现网站上的内容存在不实之处或侵犯了您的合法权益，请立即通过网站底部的联系邮箱与我们取得联系，附上相关证据材料，我们会在24小时内进行核实并作出相应处理。',
  },
];